import minBy from 'lodash/minBy'
import { BookerCalendarEvent, QueueMember } from '@chilipiper/api-type-def'
import { ExtendedLoadQueue } from './loader/types'

const findFirstOwner = (queue?: ExtendedLoadQueue, filter?: string[]) => {
  const owners = queue?.owners || []

  if (owners.length) {
    const memberOwners = queue?.members?.filter(member => owners.some(o => o === member.id)) ?? []
    return findFirstInMembers(memberOwners, filter) || memberOwners[0]
  }

  return undefined
}

const findGroupAssignee = (queue: ExtendedLoadQueue) => queue.members.find(m => m.main)

export const findFirstMember = (queue?: ExtendedLoadQueue, filter?: string[]) => {
  if (queue?.algorithm === 'Sequential') {
    return null
  }
  if (queue?.algorithm === 'Group') {
    return findGroupAssignee(queue)
  }
  if (queue?.algorithm === 'IndividualLinks') {
    return queue.members[0]
  }
  const firstOwner = findFirstOwner(queue, filter)
  const first = findFirstInMembers(queue?.members, filter)
  return firstOwner || first
}

const findFirstInMembers = (queueMembers?: QueueMember[], filter: string[] = []) => {
  const members = queueMembers?.filter(member => !filter.includes(member.id)) ?? []
  const onVacation = members.filter(member => member.onVacation)
  const accessible = members.filter(
    member => member.accessible && member.order >= 0 && !member.onVacation
  )
  const first =
    accessible.length !== 0
      ? minBy(accessible, member => member.order)
      : minBy(onVacation, member => member.order)
  return first?.id ? first : undefined
}

export const getMember = (
  queue: ExtendedLoadQueue,
  slot: BookerCalendarEvent,
  assigneeId?: string
) => {
  const filter = slot ? slot.assigneeIds : []

  let previousAssignee = assigneeId && !filter.includes(assigneeId) ? { id: assigneeId } : undefined

  // check if enableBroadReschedule is true and if the previous assignee is still in the queue
  if (queue?.enableBroadReschedule && previousAssignee) {
    previousAssignee = queue?.members.some(member => member.id === previousAssignee?.id)
      ? previousAssignee
      : undefined
  }

  return previousAssignee || findFirstMember(queue, filter)
}
